<template>
	<div class="select-div">
		<div v-for="(items,key) in selectdata" :key="key" @click="choose(items[prop.value])" :class="'select-item ' + (select.indexOf(items[prop.value])>-1?'isSelect':'')">
			<span>{{items[prop.label]}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectdata: [],
				select: []
			}
		},
		methods:{
			getdata()
			{
				if(this.data instanceof Array)
				{
					this.selectdata=this.data;
				}
				else if((typeof this.data)=='function')
				{
					this.data(this);
				}
				if(typeof this.value == "undefined" || this.value == null || this.value == ""){
					this.select=[];
				}
				else{
					this.select=this.value.split(',');
				}
			},
			choose(value)
			{
				if(this.select.indexOf(value)>-1){
					this.select.remove(value);
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.select.join(','));
					}
					o.input();
				}
				else{
					this.select.push(value);
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.select.join(','));
					}
					o.input();
				}
			}
		},
		props: {
			value: {
				type: [String,Number],
				default: ''
			},
			data: {
				type: [Array,Function],
				default: function () {
					return [];
				}
			},
			prop: {
				type: Object,
				default: function () {
					return {
						label: 'name',
						value: 'id'
					};
				}
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		mounted: function () {
			this.getdata();
		},
		computed:{
			
		},
		watch: {
			show(newval,oldval){
				this.getdata();
			},
			value(newval,oldval){
				if(typeof this.value == "undefined" || this.value == null || this.value == ""){
					this.select=[];
				}
				else{
					this.select=this.value.split(',');
				}
			}
		}
	}
</script>

<style scoped>
	.select-div{
		padding: 6px 0px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
	.select-item{
		cursor: pointer;
		border: 1px solid #DCDFE6;
		padding: 2px 10px;
		margin: 2px 5px;
		border-radius: 13px;
		font-size: 14px;
		color: #606266;
		height: 20px;
		line-height: 21px;
	}
	.isSelect{
		background-color: red;
		color: white;
		border: 1px solid red;
	}
</style>
